import { useEffect } from "react";
import { useLocation } from "@/lib/router-compat";

/**
 * Adds the `admin-shell` class to <body> whenever the route is an admin
 * route, so the compact + colorful admin CSS in index.css applies to
 * every admin page regardless of whether it wraps with <AdminLayout>.
 */
export const AdminBodyClass = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const isAdmin = pathname.startsWith("/admin");
    document.body.classList.toggle("admin-shell", isAdmin);
    return () => {
      document.body.classList.remove("admin-shell");
    };
  }, [pathname]);
  return null;
};
